// export const API_BASE_URL = "https://hkust.multiconnect.com.hk/api";
export const API_BASE_URL = "https://ailh.ust.hk/server/api";

// Chatbot has a separate base URL because the endpoints are only on the
// shared staging backend (https://hkust.multiconnect.com.hk) and the per-dev
// testing VM right now — NOT the HKUST production server.
// Resolution order:
//   1. REACT_APP_CHATBOT_BASE_URL build-time override (local dev / umi proxy)
//   2. Hostname-specific overrides for known deployments
//   3. Shared staging backend at hkust.multiconnect.com.hk (the new default;
//      CORS allows ailh.edmondchan.work + ailh.ust.hk)
const STAGING_CHATBOT_BASE_URL = "https://hkust.multiconnect.com.hk/api";

const resolveChatbotBaseUrl = (): string => {
  if (process.env.REACT_APP_CHATBOT_BASE_URL) {
    return process.env.REACT_APP_CHATBOT_BASE_URL;
  }
  // ailh-api.edmondchan.work is the testing-VM's own backend with the latest
  // SSERenderer / Professor-E persona fixes. Keep it as an explicit override
  // for developers iterating on the VM stack directly; everyone else lands
  // on staging.
  if (
    typeof window !== "undefined" &&
    window.location.search.includes("chatbot=vm")
  ) {
    return "https://ailh-api.edmondchan.work/api";
  }
  return STAGING_CHATBOT_BASE_URL;
};

const CHATBOT_BASE_URL = resolveChatbotBaseUrl();

export const API_HEADERS = {
  "Content-Type": "application/json",
};

export const API_ENDPOINTS = {
  banner: `${API_BASE_URL}/banner/`,
  sale: `${API_BASE_URL}/sale/`,
  aboutIntroduction: `${API_BASE_URL}/about-introduction/`,
  featuredPosts: `${API_BASE_URL}/featured-posts/`,
  testimonials: `${API_BASE_URL}/testimonials/`,
  contact: `${API_BASE_URL}/form/website-info/`,
  initiatives: `${API_BASE_URL}/posts/?blog_type=initiative&e_blog_status=Published&ordering=-created_at`,
  researchPosts: `${API_BASE_URL}/posts/?blog_type=research&e_blog_status=Published&ordering=-created_at`,
  posts: `${API_BASE_URL}/posts/?blog_type=blog_only&e_blog_status=Published&ordering=-created_at`,
  newsletterPosts: `${API_BASE_URL}/posts/?blog_type=newsletter&e_blog_status=Published&ordering=-created_at`,
  initiativeDetail: (id: number | string) => `${API_BASE_URL}/posts/${id}/`,
  formSubmission: `${API_BASE_URL}/form/contact/`,
  subscription: `${API_BASE_URL}/subscription/`,
  scope: `${API_BASE_URL}/scope/`,
  director: `${API_BASE_URL}/director/`,
  aboutMember: `${API_BASE_URL}/about-member/`,
  members: `${API_BASE_URL}/members/`,
  ourMission: `${API_BASE_URL}/our-mission/`,
  team: `${API_BASE_URL}/team/`,
  designThinkingWhy: `${API_BASE_URL}/design-thinking-why/`,
  designThinkingTools: `${API_BASE_URL}/tools/`,
  guide: `${API_BASE_URL}/guide/`,
  learningPackages: `${API_BASE_URL}/learning-packages/`,
  chatbotMessage: `${CHATBOT_BASE_URL}/chatbot/message/`,
  chatbotStream: `${CHATBOT_BASE_URL}/chatbot/stream/`,
  aiLiteracyTutorBanner: `${API_BASE_URL}/ai-literacy-tutor-banner/`,
  aiLiteracyTutorIntroduction: `${API_BASE_URL}/ai-literacy-tutor-introduction/`,
  aiLiteracyTutorMomentHighlight: `${API_BASE_URL}/ai-literacy-tutor-moment-highlight/`,
  aiLiteracyTutorTutors: `${API_BASE_URL}/ai-literacy-tutor-tutors/`,
  aiLiteracyTutorLearningPackages: `${API_BASE_URL}/ai-literacy-tutor-learning-packages/`,
} as const;
